import React from "react";
import {
  Box,
  Grid,
  GridItem,
  Heading,
  Flex,
  VStack,
  Text,
  Image,
} from "@chakra-ui/react";
import { FC } from "react";
import { Link } from "react-router-dom";
import { logo } from "assets/images";

const Footer: FC = () => {
  return (
    <Box
      bg="teal.500"
      color="white"
      py={{ base: 10, md: 12 }}
      px={{ base: 4, md: 8 }}
    >
      <Grid
        templateColumns={{ base: "1fr", md: "repeat(4, 1fr)" }}
        gap={8}
        maxW="container.xl"
        mx="auto"
      >
        <GridItem>
          <Heading size="md" mb={4}>
            <Image src={logo} alt="BBPS Logo" h="100px" />
          </Heading>
          <Text>
            {`India's unified bill payment platform, making digital payments simple, secure, and accessible for everyone.`}
          </Text>
        </GridItem>
        <GridItem>
          <Heading size="md" mb={4}>
            Contact
          </Heading>
          <VStack align="start" gap={2}>
            <Text>Webtooth Techno LLP</Text>
            <Text>Sector-49 Gurugram, Haryana</Text>
            <Link to="tel:+919511520346">+91 9511520346</Link>
            <Link to="mailto:connect@cashquin.com">connect@cashquin.com</Link>
          </VStack>
        </GridItem>
        <GridItem>
          <Heading size="md" mb={4}>
            <Link to="/aboutUs"> About Us</Link>
          </Heading>
          <VStack align="start" gap={2} />
        </GridItem>
      </Grid>
      <Text textAlign="center" mt={8}>
        © 2025 | Webtooth Techno LLP | All rights reserved. | A Digital India
        Initiative
      </Text>
      <Flex justifyContent="center" alignItems="center" mt={2} gap={3}>
        <Link to="/privacy-policy" style={{ textDecoration: "underline" }}>
          Privacy Policy
        </Link>
        <Text>|</Text>
        <Link
          to="/terms-and-conditions"
          style={{ textDecoration: "underline" }}
        >
          Terms & Conditions
        </Link>
        <Text>|</Text>
        <Link
          to="/refunds-cancellations"
          style={{ textDecoration: "underline" }}
        >
          Refunds & Cancellations
        </Link>
      </Flex>
    </Box>
  );
};

export default Footer;
